{
  "nl": {
    "courseCatalog": {
      "activeCourses": {
        "title": "Actieve nascholingen",
        "toCourse": "Naar de cursus"
      },
      "headers": {
        "title": "Ontdek praktijkgerichte nascholingen"
      },
      "filters": {
        "courseType": "Cursustype",
        "subjectAreas": "Themagebieden",
        "languages": "Taal",
        "order": {
          "label": "Sortering",
          "relevant": "Relevantie",
          "mostRecent": "Nieuwste",
          "rating": "Beoordeling",
          "popular": "Populariteit"
        }
      },
      "courseTypes": {
        "courses": "Nascholingen",
        "webinar": "Live-webinars",
        "recording": "Opnames",
        "impulse": "Impulsen"
      },
      "sections": {
        "liveWebinars": "Live-webinars",
        "liveWebinarsDescription": "Neem deel aan lezingen van experts met discussieruimtes en de mogelijkheid tot uitwisseling.",
        "newCourses": "Nieuwe cursussen",
        "pinned": "fobizz Favorieten",
        "pinnedDescription": "Bijzonder populaire en relevante cursussen - de actuele aanbevelingen van de fobizz redactie.",
        "impulses": "Impulsen",
        "impulsesDescription": "Ontvang compacte, praktijkgerichte inzichten in nieuwe thema's & lesideeën - in minder dan 30 minuten.",
        "courses": "Nascholingen",
        "coursesDescription": "Leer in je eigen tempo, wanneer je wilt en waar je wilt - volg zelfstudiecursussen met een hoge praktijkgerichtheid.",
        "recommendations": "Persoonlijke cursusaanbevelingen",
        "recommendationsDescription": "Een selectie van bijzonder relevante cursussen voor jou, op basis van je profielgegevens en je reeds gevolgde of opgeslagen cursussen.",
        "recordings": "Webinar-opnames",
        "recordingsDescription": "Volg eerdere live-webinars via de opnames en verdiep je kennis heel flexibel."
      },
      "links": {
        "showAllWebinars": "Alle live-webinars weergeven",
        "showAllCourses": "Alle nascholingen weergeven",
        "showAllImpulses": "Alle impulsen weergeven",
        "showAllRecordings": "Alle webinar-opnames weergeven"
      },
      "search": {
        "placeholder": "Nascholingen doorzoeken...",
        "noResults": "Helaas hebben we geen cursussen gevonden met deze zoekcriteria."
      },
      "subjectAreas": {
        "subject_area_didactic": "Didactiek & lesontwerp",
        "subject_area_media_education": "Mediawijsheid & mediakritiek",
        "subject_area_collaboration": "Team- en relatiegericht werken",
        "subject_area_school_development": "Schoolontwikkeling & leiderschap",
        "subject_area_performance": "Prestatie, feedback & leerstand",
        "subject_area_diversity": "Inclusie, differentiatie & taalvorming",
        "subject_area_health": "Gezondheid & professionalisering",
        "subject_area_ki": "Kunstmatige intelligentie",
        "subject_area_tools": "Digitale tools & toepassingen",
        "subject_area_kids_world": "Leerlingenwerelden & samenleving",
        "subject_area_chances": "Startkansen",
        "subject_area_programming": "Programmeren & informatica"
      },
      "teaser": {
        "title": "Ontvang individuele nascholingsaanbevelingen",
        "linkName": "Naar de AI-nascholingsfinder"
      },
      "languages": {
        "de": "Duits",
        "en": "Engels",
        "fr": "Frans",
        "es": "Spaans",
        "nl": "Nederlands"
      }
    }
  }
}
